const LISTAR_DADOS = (state, payload) => {
    state.items = payload
}

const LISTAR_DADOS_TIPOS_AGINGS = (state, payload) => {
    state.tipoAgings = payload
}

const LISTAR_MACRO_PROCESSOS = (state, payload) => {
  state.macroProcessos = payload
}

const LISTAR_PROCESSOS_HIERARQUIAS = (state, payload) => {
  state.processosHierarquias = payload
}

const CARREGANDO = (state, payload) => {
  state.carregando = payload
}

const INSERIR_PROCESSO_SELECIONADO = (state,  payload) => {
  state.selecionado = payload
}

export {
    LISTAR_DADOS,
    LISTAR_DADOS_TIPOS_AGINGS,
    LISTAR_MACRO_PROCESSOS,
    CARREGANDO,
    INSERIR_PROCESSO_SELECIONADO,
    LISTAR_PROCESSOS_HIERARQUIAS
}